import { HubConnection } from '@aspnet/signalr'
import React, { Component, ReactNode } from 'react'

// import { SignalRService } from './signal-r.service'

// import { ENDPOINT } from '../../environment'

const initialState = {
  connection: null as HubConnection | null,
  connectionError: false,
}

// const HUB_NAME = 'hubs/front-face'

// const hubUrl = `${ENDPOINT}/${HUB_NAME}`

// const service = new SignalRService(hubUrl)

export const SignalRContext = React.createContext(initialState)

type Props = {
  children: ReactNode
}
type State = typeof initialState

export class SignalRConnectionProvider extends Component<Props, State> {
  readonly state: State = initialState

  render() {
    return this.props.children // REMOVE THIS LINE WHEN SIGNALR WILL BE ENABLED AGAIN

    // const { connectionError, connection } = this.state

    // if (connectionError) {
    //   return this.props.children
    // }

    // return connection ? (
    //   <SignalRContext.Provider value={this.state}>{this.props.children}</SignalRContext.Provider>
    // ) : null
  }

  componentDidMount() {
    // service.start(
    //   (connection) =>
    //     this.setState({
    //       connection,
    //     }),
    //   (reason) =>
    //     this.setState({
    //       connectionError: true,
    //     })
    // )
  }
}



// WEBPACK FOOTER //
// ./src/modules/signal-r/connection-provider.tsx